<template>
	  <component :is="componentMap[type]" v-model="queryTerm" :vhost="vhost" @on-select="handleSelect" @on-filter="showFilter"></component>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue';
import MediaSearchField from '@/components/MediaSearchField.vue';
import UserSearchField from '@/components/UserSearchField.vue';
import MetaSearchField from '@/components/MetaSearchField.vue';

export default defineComponent({
	  name: 'DynamicSearchField',
	  components: {
		      MediaSearchField,
		      UserSearchField,
		      MetaSearchField,
		    },
	  props: {
		      type: {
			            type: String as () => 'media' | 'user' | 'meta',
			            required: true,
			          },
		      vhost: {
			            type: String,
			            required: true,
			          },
		      modelValue: {
			            type: String,
			            required: true,
			          },
		    },
	  emits: ['update:modelValue', 'on-select','on-filter'],
	  setup(props, { emit }) {
		      // Map the `type` prop to the corresponding component
		      const componentMap = {
			            media: MediaSearchField,
			            user: UserSearchField,
			            meta: MetaSearchField,
			          };

		      // Handle v-model binding
		      const queryTerm = computed({
			            get: () => props.modelValue,
			            set: (value) => emit('update:modelValue', value),
			          });

		      const showFilter = (type: string) => {
			      console.log('InDyn',type);
			            emit('on-filter', type);
			          };

		      // Handle the `@on-select` event
		      const handleSelect = (selectedItem: any) => {
			            emit('on-select', selectedItem);
			          };

		      return {
			            componentMap,
			            queryTerm,
			            handleSelect,
			            showFilter,
			          };
		    },
});
</script>
